define('glu/locale/requireJsLocale',['require','./localeBase'],function(require) {
    'use strict';

    var locale = require('./localeBase');

    /**
     * Sets up locale to work with requireJs using urls that point directly to each locale bundle.
     *
     * @param url Required Url to use to load the the bundle.
     * @param callback Optional function to call with the bundle once it is loaded.
     */
    locale.fetchFunction = function fetch(url, callback) {
        require([url], function(bundle) {
            this.loadFetchedBundle(bundle, callback);
        }.bind(this));
    };

    return locale;
});

